import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { OnboardingService } from '../../services/onboarding.service';
import { MigrationModeService } from '../../services/migration-mode.service';
import { TokenStorageService } from '../token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardingGuard implements CanActivate {
  constructor(
    private onboardingService: OnboardingService,
    private migrationModeService: MigrationModeService,
    private router: Router,
    private tokenStorage: TokenStorageService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    // C29: no tenant to ask about; AuthGuard beside this one sends it to /profiles.
    if (this.tokenStorage.isPickerSession()) {
      return true;
    }

    // Waiter and kitchen sessions never onboard; MarsOnlyGuard beside this
    // one sends them to their own screen.
    if (this.tokenStorage.isMarsOnly()) {
      return true;
    }

    if (this.migrationModeService.getCurrentMode() === 'legacy') {
      return true;
    }

    try {
      const status = await firstValueFrom(this.onboardingService.getStatus());

      if (status.onboarding_completed) {
        return true;
      }

      const normalizedUrl = this.onboardingService.normalizeUrl(state.url);

      if (this.onboardingService.isRouteAllowed(normalizedUrl, status)) {
        return true;
      }

      const currentStep = this.onboardingService.getCurrentStep(status);
      const targetRoute = this.onboardingService.getRouteForStep(currentStep);
      return this.router.createUrlTree([targetRoute]);
    } catch (error) {
      console.error('OnboardingGuard error:', error);
      return true;
    }
  }
}
